module.exports = __webpack_public_path__ + "img/feature_buy_en.8e968f55.png";